"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogsHistoryModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const io5_1 = require("react-icons/io5");
const react_inspector_1 = require("react-inspector");
const ui_1 = require("react-science/ui");
const LoggerContext_1 = require("../context/LoggerContext");
const Button_1 = __importDefault(require("../elements/Button"));
const ColumnWrapper_1 = require("../elements/ColumnWrapper");
const ReactTable_1 = __importDefault(require("../elements/ReactTable/ReactTable"));
const logsDataFormat = new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
});
function handleRowStyle(data) {
    const level = (data?.original).level;
    let backgroundColor = 'lightgreen';
    if (level > 40) {
        backgroundColor = 'pink';
    }
    else if (level === 40) {
        backgroundColor = 'lightyellow';
    }
    return { base: { backgroundColor } };
}
function getMaxLevelLogs(logs, lastReadLogId) {
    const logsCounts = {};
    for (const log of logs) {
        if (log.id > lastReadLogId) {
            logsCounts[log.level] = ++logsCounts[log.level] || 1;
        }
    }
    let maxLevel = 0;
    for (const levelKey in logsCounts) {
        const level = Number(levelKey);
        if (level > maxLevel) {
            maxLevel = level;
        }
    }
    let backgroundColor = '#2dd36f';
    if (maxLevel > 40) {
        backgroundColor = '#ff0000';
    }
    else if (maxLevel === 40) {
        backgroundColor = '#ffc409';
    }
    return { backgroundColor, count: logsCounts[maxLevel] };
}
function LogsHistoryModal(props) {
    const { autoOpen = false, onClose } = props;
    const { logsHistory, logger, markAsRead, lastReadLogId } = (0, LoggerContext_1.useLogger)();
    const [isOpenDialog, openDialog, closeDialog] = (0, ui_1.useOnOff)(autoOpen);
    const { count, backgroundColor } = getMaxLevelLogs(logsHistory, lastReadLogId);
    const COLUMNS = (0, react_1.useMemo)(() => [
        {
            Header: '#',
            accessor: (_, index) => index + 1,
            Cell: ({ row }) => ((0, jsx_runtime_1.jsxs)("span", { children: [row.original.id > lastReadLogId && ((0, jsx_runtime_1.jsx)("div", { style: {
                            width: '5px',
                            height: '5px',
                            borderRadius: '50%',
                            backgroundColor: '#ffc409',
                            display: 'inline-block',
                            margin: '0 3px',
                        } })), row.index + 1] })),
            style: { width: '40px' },
        },
        {
            Header: 'Time',
            accessor: (row) => logsDataFormat.format(row.time),
            style: { width: '100px' },
        },
        {
            Header: 'Label',
            accessor: 'levelLabel',
            style: { width: '60px' },
        },
        {
            Header: 'Message',
            accessor: 'message',
        },
        {
            Header: 'Error',
            Cell: ({ row }) => {
                const { error } = row.original;
                return ((0, jsx_runtime_1.jsx)(ColumnWrapper_1.ColumnWrapper, { children: (0, jsx_runtime_1.jsx)(react_inspector_1.ObjectInspector, { data: error || {} }) }));
            },
        },
    ], [lastReadLogId]);
    const sortedLogs = logsHistory.slice().sort((a, b) => b.time - a.time);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!autoOpen && ((0, jsx_runtime_1.jsx)(Button_1.default.BarButton, { onClick: () => {
                    openDialog();
                }, children: (0, jsx_runtime_1.jsxs)("div", { style: { position: 'relative' }, children: [(0, jsx_runtime_1.jsx)(io5_1.IoBugOutline, { fontSize: "1.4em" }), count && ((0, jsx_runtime_1.jsx)("span", { style: {
                                position: 'absolute',
                                top: '-0.4em',
                                left: '-0.4em',
                                backgroundColor,
                                borderRadius: '50%',
                                minWidth: '14px',
                                fontSize: '0.75em',
                                color: 'white',
                            }, children: count }))] }) })), (0, jsx_runtime_1.jsxs)(ui_1.Modal, { hasCloseButton: true, isOpen: isOpenDialog, onRequestClose: () => {
                    markAsRead();
                    closeDialog();
                    onClose?.();
                }, children: [(0, jsx_runtime_1.jsx)(ui_1.Modal.Header, { children: "Logs History " }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Body, { children: (0, jsx_runtime_1.jsx)("div", { style: { width: '50vw', height: '50vh', padding: '0.5em' }, children: (0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: COLUMNS, data: sortedLogs, emptyDataRowText: "No Logs", rowStyle: handleRowStyle }) }) }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Footer, { children: (0, jsx_runtime_1.jsx)(Button_1.default.Danger, { onClick: () => logger.clear(), fill: "outline", children: (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(fa_1.FaRegTrashAlt, {}), (0, jsx_runtime_1.jsx)("span", { style: { paddingLeft: '5px' }, children: "Clear Logs" })] }) }) })] })] }));
}
exports.LogsHistoryModal = LogsHistoryModal;
